module.exports = __webpack_public_path__ + "images/sport-fritid.680628e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/EbaySweden.TouchWeb/static/images/category-carousel/sport-fritid.jpg
// module id = 462416c0
// module chunks = 6 16